<template>
	<div class="col-2 no-flex sidebar hide-on-mobile">
		<img src="/img/Logo.png" alt="Bisa Cek" class="mx-auto d-block img-fluid" width="80%">
		<hr class="mx-auto mb-4" style="width: 80%;">
		<h5 class="ml-4 mb-0"><strong>Hello, {{name}}</strong></h5>
		<small class="ml-4">Selamat bekerja</small>
		<hr class="mx-auto mb-4" style="width: 80%;">
		<ul>
			<router-link tag="li" to="/dashboard" exact><span><img src="/img/icon-3/dashboard.png" height="30px"></span> Halaman Utama</router-link>
			<router-link tag="li" to="/expedition"><span><img src="/img/icon-3/trip.png" height="30px"></span> Trip</router-link>
			<router-link tag="li" to="/shipment"><span><img src="/img/icon-3/shipment.png" height="30px"></span> Shipment</router-link>
			<router-link tag="li" to="/contact"><span><img src="/img/icon-3/contact.png" height="30px"></span> Kontak Pelanggan</router-link>
			<router-link tag="li" to="/price"><span><img src="/img/icon-3/route_price.png" height="30px"></span> Rute &amp; Harga</router-link>
			<router-link tag="li" to="/driver"><span><img src="/img/icon-3/driver.png" height="30px"></span> Personel</router-link>
			<router-link tag="li" to="/device"><span><img src="/img/icon-3/device.png" height="30px"></span> Perangkat Komunikasi</router-link>
			<router-link tag="li" to="/vehicle"><span><img src="/img/icon-3/vehicle.png" height="30px"></span> Kendaraan</router-link>
			<router-link tag="li" to="/report"><span><img src="/img/icon-3/report.png" height="30px"></span> Laporan</router-link>
			<router-link tag="li" to="/setting"><span><img src="/img/icon-3/setting.png" height="30px"></span> Pengaturan</router-link>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'DesktopMenu',
	data(){
		return {
			role: 2,
			name: localStorage.getItem('name')
		}
	}
}
</script>